import script from "./AccountDeletion.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDeletion.vue?vue&type=script&setup=true&lang=js"

import "./AccountDeletion.vue?vue&type=style&index=0&id=17ef6f44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17ef6f44"]])

export default __exports__